// export const WeekDates = () => {
//   Monday: new Date();
//   Tuesday: new Date();
//   Wednesday: new Date();
//   Thursday: new Date();
//   Friday: new Date();
//   Saturday: new Date();
// };

import { formDateFormat, VERIFICATION_BASE_URL } from '../../../constants';
import moment from 'moment';
import { getVerificationGroupMasterReferenceData } from '../../../redux/verification/verificationGroupMasterData';
import { getVerificationDynamicMasterReferenceData } from '../../../redux/verification/verificationDynamicMasterDate';
import { getVerificationDischargeMasterReferenceData } from '../../../redux/verification/verificationDischargeMasterData';
import { getVerificationIndividual1MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationIndividual1';
import { getVerificationIndividual3MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationIndividual3';
import { getVerificationIndividual4MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationIndividual4';
import { getVerificationIndividual5MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationIndividual5';
import { getVerificationIndividual6MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationIndividual6';
import { getVerificationIndividual7MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationIndividual7';
import { getVerificationGroup1MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationGroup1';
import { getVerificationGroup3MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationGroup3';
import { getVerificationGroup4MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationGroup4';
import { getVerificationGroup5MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationGroup5';
import { getVerificationGroup6MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationGroup6';
import { getVerificationGroup7MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationGroup7';
import { getVerificationDischarge1MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationDischarge1';
import { getVerificationDischarge3MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationDischarge3';
import { getVerificationDischarge4MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationDischarge4';
import { getVerificationDischarge5MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationDischarge5';
import { getVerificationDischarge6MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationDischarge6';
import { getVerificationDischarge7MasterReferenceData } from '../../../redux/verification/verificationDropdowns/verificationDischarge7';

// export const FillWeekDates = (startDate) => {
//   week = WeekDates();
//   week.Monday = new Date(startDate);
//   week.Tuesday.setDate(startDate.getDate() + 1);
//   week.Wednesday.setDate(startDate.getDate() + 2);
//   week.Thursday.setDate(startDate.getDate() + 3);
//   week.Friday.setDate(startDate.getDate() + 4);
//   week.Saturday.setDate(startDate.getDate() + 5);

//   return week;
// };

export const getCommonDropDownIndividual1 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  i1TmtOrgInvBilledYnValue
) => {
  const payload = {
    CBPId: CBPId,
    TmtType: 'I',
    ActiveDate: activeDateValue,
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      i1TmtOrgInvBilledYnValue === null ? false : i1TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationIndividual1MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownIndividual2 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  i2TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const tuesday = newWeekDate.setDate(newWeekDate.getDate() + 1);
  const payload = {
    CBPId: CBPId,
    TmtType: 'I',
    ActiveDate: moment(tuesday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      i2TmtOrgInvBilledYnValue === null ? false : i2TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationDynamicMasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownIndividual3 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  i3TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const wednesday = newWeekDate.setDate(newWeekDate.getDate() + 2);
  const payload = {
    CBPId: CBPId,
    TmtType: 'I',
    ActiveDate: moment(wednesday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      i3TmtOrgInvBilledYnValue === null ? false : i3TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationIndividual3MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownIndividual4 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  i4TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const thursday = newWeekDate.setDate(newWeekDate.getDate() + 3);
  const payload = {
    CBPId: CBPId,
    TmtType: 'I',
    ActiveDate: moment(thursday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      i4TmtOrgInvBilledYnValue === null ? false : i4TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationIndividual4MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownIndividual5 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  i5TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const friday = newWeekDate.setDate(newWeekDate.getDate() + 4);
  const payload = {
    CBPId: CBPId,
    TmtType: 'I',
    ActiveDate: moment(friday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      i5TmtOrgInvBilledYnValue === null ? false : i5TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationIndividual5MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownIndividual6 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  i6TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const saturday = newWeekDate.setDate(newWeekDate.getDate() + 5);
  const payload = {
    CBPId: CBPId,
    TmtType: 'I',
    ActiveDate: moment(saturday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      i6TmtOrgInvBilledYnValue === null ? false : i6TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationIndividual6MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownIndividual7 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  i7TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const sunday = newWeekDate.setDate(newWeekDate.getDate() + 6);
  const payload = {
    CBPId: CBPId,
    TmtType: 'I',
    ActiveDate: moment(sunday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      i7TmtOrgInvBilledYnValue === null ? false : i7TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationIndividual7MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownGroup1 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  g1TmtOrgInvBilledYnValue
) => {
  const payload = {
    CBPId: CBPId,
    TmtType: 'G',
    ActiveDate: activeDateValue,
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      g1TmtOrgInvBilledYnValue === null ? false : g1TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationGroup1MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownGroup2 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  g2TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const tuesday = newWeekDate.setDate(newWeekDate.getDate() + 1);
  const payload = {
    CBPId: CBPId,
    TmtType: 'G',
    ActiveDate: moment(tuesday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      g2TmtOrgInvBilledYnValue === null ? false : g2TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationGroupMasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownGroup3 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  g3TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const wednesday = newWeekDate.setDate(newWeekDate.getDate() + 2);
  const payload = {
    CBPId: CBPId,
    TmtType: 'G',
    ActiveDate: moment(wednesday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      g3TmtOrgInvBilledYnValue === null ? false : g3TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationGroup3MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownGroup4 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  g4TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const thursday = newWeekDate.setDate(newWeekDate.getDate() + 3);
  const payload = {
    CBPId: CBPId,
    TmtType: 'G',
    ActiveDate: moment(thursday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      g4TmtOrgInvBilledYnValue === null ? false : g4TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationGroup4MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownGroup5 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  g5TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const friday = newWeekDate.setDate(newWeekDate.getDate() + 4);
  const payload = {
    CBPId: CBPId,
    TmtType: 'G',
    ActiveDate: moment(friday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      g5TmtOrgInvBilledYnValue === null ? false : g5TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationGroup5MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownGroup6 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  g6TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const saturday = newWeekDate.setDate(newWeekDate.getDate() + 5);
  const payload = {
    CBPId: CBPId,
    TmtType: 'G',
    ActiveDate: moment(saturday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      g6TmtOrgInvBilledYnValue === null ? false : g6TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationGroup6MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownGroup7 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  g7TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const sunday = newWeekDate.setDate(newWeekDate.getDate() + 6);
  const payload = {
    CBPId: CBPId,
    TmtType: 'G',
    ActiveDate: moment(sunday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      g7TmtOrgInvBilledYnValue === null ? false : g7TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationGroup7MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownDischarge1 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  d1TmtOrgInvBilledYnValue
) => {
  const payload = {
    CBPId: CBPId,
    TmtType: 'D',
    ActiveDate: activeDateValue,
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      d1TmtOrgInvBilledYnValue === null ? false : d1TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationDischarge1MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownDischarge2 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  d2TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const tuesday = newWeekDate.setDate(newWeekDate.getDate() + 1);
  const payload = {
    CBPId: CBPId,
    TmtType: 'D',
    ActiveDate: moment(tuesday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      d2TmtOrgInvBilledYnValue === null ? false : d2TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationDischargeMasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownDischarge3 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  d3TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const wednesday = newWeekDate.setDate(newWeekDate.getDate() + 2);
  const payload = {
    CBPId: CBPId,
    TmtType: 'D',
    ActiveDate: moment(wednesday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      d3TmtOrgInvBilledYnValue === null ? false : d3TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationDischarge3MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownDischarge4 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  d4TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const thursday = newWeekDate.setDate(newWeekDate.getDate() + 3);
  const payload = {
    CBPId: CBPId,
    TmtType: 'D',
    ActiveDate: moment(thursday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      d4TmtOrgInvBilledYnValue === null ? false : d4TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationDischarge4MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownDischarge5 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  d5TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const friday = newWeekDate.setDate(newWeekDate.getDate() + 4);
  const payload = {
    CBPId: CBPId,
    TmtType: 'D',
    ActiveDate: moment(friday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      d5TmtOrgInvBilledYnValue === null ? false : d5TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationDischarge5MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownDischarge6 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  d6TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const saturday = newWeekDate.setDate(newWeekDate.getDate() + 5);
  const payload = {
    CBPId: CBPId,
    TmtType: 'D',
    ActiveDate: moment(saturday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      d6TmtOrgInvBilledYnValue === null ? false : d6TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationDischarge6MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

export const getCommonDropDownDischarge7 = async (
  CBPId,
  activeDateValue,
  intMed,
  SapAthId,
  sundayDate,
  StartMonday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  d7TmtOrgInvBilledYnValue
) => {
  const newWeekDate = new Date(activeDateValue);
  const sunday = newWeekDate.setDate(newWeekDate.getDate() + 6);
  const payload = {
    CBPId: CBPId,
    TmtType: 'D',
    ActiveDate: moment(sunday).format(formDateFormat),
    MedCount: intMed,
    SapAthId: SapAthId,
    SundayDate: sundayDate,
    StartMonday: StartMonday,
    MinTmtDate: MinTmtDateValue === null ? null : MinTmtDateValue.split('T')[0],
    TmtOrgInvBilledYn:
      d7TmtOrgInvBilledYnValue === null ? false : d7TmtOrgInvBilledYnValue,
    SapAthAdmitDate:
      SapAthAdmitDateValue === null ? null : SapAthAdmitDateValue.split('T')[0],
    SapAthStartDate:
      SapAthStartDateValue === null ? null : SapAthStartDateValue.split('T')[0],
    SapAthOvrlEndDate:
      SapAthEndDateValue === null ? null : SapAthEndDateValue.split('T')[0],
    CheckAdm: checkAdmValue,
  };
  const url = `${VERIFICATION_BASE_URL}/treatmetStatus/list`;
  const authorization = authToken;
  dispatch(
    getVerificationDischarge7MasterReferenceData({
      url,
      payload,
      authorization,
    })
  );
};

